import React, { useEffect, useState } from "react";
import * as API from "../../utils/api.service";
import { TOAST_ERROR } from "../../utils/common.service";
import { useParams } from "react-router-dom";

const PrivacyPolicy = () => {
  const { lang } = useParams();
  const [privacyPolicy, setPrivacyPolicy] = useState("");

  useEffect(() => {
    const fetchPrivacyPolicyContent = async () => {
      try {
        const response = await API.getAppContentApi();
        if (lang == "ar") {
          setPrivacyPolicy(response.data.ar_policy_content);
        } else {
          setPrivacyPolicy(response?.data?.policy_content || "");
        }
      } catch (error) {
        TOAST_ERROR("Failed to load content");
      }
    };

    fetchPrivacyPolicyContent();
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="content" dir={lang === "ar" ? "rtl" : "ltr"}>
            <h1 className="d-flex justify-content-center mt-3 mb-3">
              {lang == "ar" ? "سياسة الخصوصية" : "Privacy Policy"}
            </h1>
            <div dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
